/**
* @ngdoc service
* @name common.newsletter.service:ItxNewsletterSvc
* @requires $q
* @description
* Newsletter service
*/
(function () {
    
    'use strict';

    angular.module('itxApp.common')
           .service('ModalSvc', ModalSvc);

    ModalSvc.$inject = [
        'ItxChatSvc',
        'ngDialog'
    ];

    function ModalSvc (
        ItxChatSvc,
        ngDialog
    ) {

        var service = {
            openContact: _openModalContact
        };
        return service;

        function _openModalContact(text) {
            var dialog = ngDialog.open({
                template: '<itx-contact close="closeThisDialog()"></itx-contact>',
                plain: true,
                className: 'contact-dialog ngdialog-theme-plain new-modal',
                showClose: true
            });
            
            document.body.addEventListener('click', function(e) {
                if($(e.target).hasClass('openChat')) {
                    dialog.close();
                    // ItxChatSvc.showChat();
                }
            });
        }
    }

})();